import React from 'react';
import { Button, Heading, Paragraph } from 'bumbag';

import LandingPage from '@medipass/react-core/Layout/LandingPage';
import { Link as RouterLink } from '@medipass/react-core/router';

import { getKeyFromQueryParams } from 'legacy/utils/router';
type Props = {};
type State = {
  error?: string;
};
export default class Error extends React.Component<Props, State> {
  state = {
    error: getKeyFromQueryParams('error'),
  };
  render = () => {
    const { error } = this.state;
    return (
      <LandingPage title="An error occurred">
        <Heading paddingBottom="major-2">Something went wrong...</Heading>
        {error && <Paragraph>{error}</Paragraph>}
        {/* @ts-expect-error TS(2322): Type '{ children: string; use: any; to: string; va... Remove this comment to see the full error message */}
        <Button use={RouterLink} to="/" variant="outlined" palette="secondary">
          Go to My Medipass
        </Button>
      </LandingPage>
    );
  };
}
